import store from '../store';

export default function approximateValue() {
  if (store.getters.getOneETHtoUSD) {
    return Number((store.getters.getEthToUSDPrice + store.getters.getOneETHtoUSD) / 2);
  }
  return 0;
}
